import { darkColors, lightColors } from "../../theme/colors";
export var light = {
    handleBackground: lightColors.backgroundAlt
};
export var dark = {
    handleBackground: darkColors.backgroundAlt
};
